var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrapezoid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90963 2.14673C5.05659 1.75755 5.42914 1.5 5.84515 1.5H14.5885C15.0182 1.5 15.3998 1.77446 15.5365 2.18178L18.5575 11.1818C18.775 11.8297 18.2929 12.5 17.6095 12.5H2.44655C1.74736 12.5 1.26402 11.8008 1.51103 11.1467L4.90963 2.14673Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrapezoid);
export default __webpack_public_path__ + "static/media/trapezoid.258aa572e2ce45ee564412ba3648aa93.svg";
export { ForwardRef as ReactComponent };